import React from "react";
import ProjectModal from "./ProjectModal";

const ProjectDetails = ({ openModal, setOpenModal }) => {
  if (!openModal?.state || !openModal?.project) return null;

  return (
    <ProjectModal
      project={openModal.project}
      onClose={() => setOpenModal({ state: false, project: null })}
    />
  );
};

export default ProjectDetails;
export { ProjectModal };
